(() => {
  let popupChecks = 0;
  const finishPopupButtons = () => {
    const root = document.getElementById('pop-convert-app')?.shadowRoot;
    if (root) {
      if (!root.getElementById('lpon-classique-popup-style')) {
        const style = document.createElement('style');
        style.id = 'lpon-classique-popup-style';
        style.textContent = '.pc-campaign-396816 .submit-button.form-block-submit-button,.submit-button.submit-button.submit-button{border-radius:2px!important;background:#24211e!important;color:#fffdf9!important;box-shadow:none!important;transform:none!important;min-height:48px!important}';
        root.append(style);
      }
      return;
    }
    if (++popupChecks < 20) window.setTimeout(finishPopupButtons, 1000);
  };
  finishPopupButtons();
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (reduced.matches || !('IntersectionObserver' in window)) return;
  const targets = document.querySelectorAll('.classique-journal-card,.classique-directory-grid>a,.section-heading,.quiz-cta>div,.notes-intro,.note-card');
  const observer = new IntersectionObserver(entries => {
    for (const entry of entries) {
      if (!entry.isIntersecting) continue;
      entry.target.classList.add('classique-visible');
      observer.unobserve(entry.target);
    }
  }, { threshold: 0.08 });
  targets.forEach((element, index) => {
    element.style.setProperty('--classique-delay', `${(index % 3) * 65}ms`);
    if (element.getBoundingClientRect().top > window.innerHeight) element.classList.add('classique-reveal');
    observer.observe(element);
  });
  const sync = () => document.body.classList.toggle('classique-paused', document.hidden || reduced.matches);
  document.addEventListener('visibilitychange', sync);
  reduced.addEventListener('change', () => {
    sync();
    if (reduced.matches) {
      observer.disconnect();
      targets.forEach(element => element.classList.add('classique-visible'));
    }
  });
})();
